import styled from "@emotion/styled";

export const StyleFormWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  position: relative;
  width: 100%;
  min-width: 0px;
  .ql-editor {
    min-height: 150px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    resize: vertical;
  }
  .ql-toolbar {
    padding: 20px 10px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
  .ql-container {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  ${(props) => props.styleWrapper}
`;
export const StyleErrorMessage = styled.p<any>`
  font-size: 12px;
  color: ${(props) => props.theme.colors.danger};
`;
export const StylePlaceholder = styled.p<any>`
  font-size: 14px;
  color: #b9b9b9;
  font-weight: 300;
`;

export const StyleLabel = styled.label<any>`
  font-size: 15px;
  font-weight: 600;

  color: ${(props) =>
    props?.hasError ? props.theme.colors.danger : props.theme.colors.text};
  ${(props) => props.styleLabel}
`;

export const StyleInputWrapper = styled.div`
  position: relative;
`;

export const StyleTextContaienr = styled.div`
  padding: 0px 12px;
  display: flex;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.25px;
  border-radius: 6px;
  height: 50px;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
